import { addStationConstants } from "./addStationConstant";

const AddStationAction = {};

AddStationAction.postAddStation = (payload) => {
    return {
        type: addStationConstants.ADD_STATION_SAGA,
        payload:payload
    }
};

export { AddStationAction };